import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MultiCountryCurrencyPipe} from './multi-country-currency.pipe';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [MultiCountryCurrencyPipe],
  exports: [MultiCountryCurrencyPipe],
})
export class MultiCountryCurrencyModule { }
